import Feature from "ol/Feature";
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Circle } from "ol/style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import { MyMap } from "../View/MyMap";

const featureStyleByGeomType = (type) => {
  return [
    type == "Point"
      ? new Style({
          image: new Circle({
            radius: 14,
            fill: new Fill({ color: "rgba(255, 165, 0,0.8)" }),
            stroke: new Stroke({
              color: "white",
              width: 2,
            }),
          }),
        })
      : type == "Polygon"
      ? new Style({
          stroke: new Stroke({
            color: "#B22222",
            width: 5,
          }),
          fill: new Fill({
            color: "orange",
          }),
        })
      : new Style({
          stroke: new Stroke({
            color: "#f79224",
            width: 10,
          }),
        }),
  ];
};

export const tempLayer = new VectorLayer({
  opacity: 1,
  name: "TempLayer",
  visible: true,
  zIndex: 300,
  source: new VectorSource({}),
});

export const addFeaturesTotempLayer = (data) => {
  let f;
  data.map((d) => {
    return d.geojson != null
      ? ((f = new Feature({
          geometry: new GeoJSON().readFeature(d.geojson).getGeometry(), // eslint-disable-next-line
        })),
        f.set("id", d.id),
        f.set("type", d.type),
        f.set("label1", d.label1),
        console.log(f.getGeometry().getType()),
        f.setStyle(featureStyleByGeomType(f.getGeometry().getType())),
        tempLayer.getSource().addFeature(f))
      : null;
  });
};

export const addSingleFeatureTotempLayerByGeojson = (data, clean) => {
  if (clean === undefined || clean === true) {
    tempLayer.getSource().clear();
  }
  if (data.geojson == null) {
    console.log("Gösterilecek Geojson Bulunamadı.");
    return;
  }

  let feature = new Feature({
    geometry: new GeoJSON().readFeature(data.geojson).getGeometry(), // eslint-disable-next-line
  });
  console.log(feature.getGeometry().getType());
  feature.setStyle(featureStyleByGeomType(feature.getGeometry().getType()));
  tempLayer.getSource().addFeature(feature);
};

export const addSingleFeatureTotempLayerByXY = (x, y, clean) => {
  if (clean === undefined || clean === true) {
    tempLayer.getSource().clear();
  }
  if (x == null || y == null) {
    console.log("Gösterilecek X/Y Bulunamadı.");
    return;
  }
  let feature = new Feature(
    { geometry: new Point([x, y]) } // eslint-disable-next-line
  );
  feature.setStyle(featureStyleByGeomType(feature.getGeometry().getType()));
  tempLayer.getSource().addFeature(feature);
};

export const zoomToFeatureByXY = (x, y, zoomLevel) => {
  let feature = new Feature(
    { geometry: new Point([x, y]) } // eslint-disable-next-line
  );
  MyMap.getView().fit(feature.getGeometry().getExtent(), { maxZoom: zoomLevel == undefined ? 21 : zoomLevel, duration: 2000 });
};

export const zoomToFeatureByGeojson = (geojson) => {
  if (geojson == null) {
    return;
  }
  let feature = new Feature({
    geometry: new GeoJSON().readFeature(geojson).getGeometry(), // eslint-disable-next-line
  });
  MyMap.getView().fit(feature.getGeometry().getExtent(), { maxZoom: 21, duration: 2000 });
};
